import React from "react";
import Button from '@mui/material/Button';
import PatientAction from "./patientActionButtons";


const AttendantDetails = () => {
    return (
        <><PatientAction />
        <form>
            <div className="Attendant-Details-info" >
                <div className="mt-3 ml-4"> <h4>Attendant</h4></div>
                <div className="row" style={{ marginLeft:0, marginRight: 0 }}>
                    <div className="form-group col-md-6">
                        <label for="fname" className="control-label col-sm">Attendant Name</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="fname" placeholder="Attendant Name" />
                        </div>
                    </div>
                     <div className="form-group col-md-6">
                        <label for="lname" className="control-label col-sm">Relation</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="lname" placeholder="Relation" />
                        </div>
                    </div>
                   <div className="form-group col-md-6">
                        <label for="fname" className="control-label col-sm">Mobile Number</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="fname" placeholder="Mobile Number" />
                        </div>
                    </div>
                    <div className="form-group col-md-6">
                        <label for="lname" className="control-label col-sm">Emergency Contact Number</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="lname" placeholder="Emergency Contact Number" />
                        </div>
                    </div>
                    <div className="form-group col-md-6">
                        <label for="fname" className="control-label col-sm">Address</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="fname" placeholder="Address" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-end mr-4 mb-3">
                <Button variant="outlined">Submit</Button>
            </div>
        </form>
        </>
    );
};

export default AttendantDetails; 